const httpServicesKey = ['httpServices'] as const

export const httpServicesKeys = {
  all: httpServicesKey,
  list: () => [...httpServicesKey, 'list'] as const,
}
